<main>
  <ag-announcements-banner></ag-announcements-banner>
  @if (filterStaffList) {
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="back-offset-two color-header-color"
    >
      <!-- mobile control panel -- START-->
      <!-- Search Dashboard -->
      @if (searchText) {
        <ng-container [formGroup]="searchText">
          <mat-form-field subscriptSizing="dynamic" fxFlex class="form-field-toolbar">
            @if (searchText?.controls['searchInput']?.value.length >= 1) {
              <button
                mat-icon-button
                matPrefix
                type="button"
                matTooltip="Clear Search"
                (click)="clearDash()"
              >
                <mat-icon>clear</mat-icon>
              </button>
            } @else {
              <button mat-icon-button matPrefix type="button">
                <mat-icon>search</mat-icon>
              </button>
            }
            <input
              matInput
              agAutofocus
              formControlName="searchInput"
              autocomplete="off"
              title="Search Staff Dashboard"
              id="typeahead-staff"
              type="text"
              placeholder="Search Staff Dashboard"
            />
          </mat-form-field>
        </ng-container>
      }
      <!-- Toggle Menu -->
      <button mat-button type="button" (click)="toggleAll()">
        <mat-icon>{{ expandedAll ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
        Toggle Menu
      </button>
      <!-- END - mobile control panel -->
    </div>
  }
  <div class="container-fluid">
    <div class="row">
      @if (quickMenuList && filterStaffList) {
        <div class="quickmenu-container d-none d-md-block">
          <mat-card appearance="outlined">
            <mat-card-title>
              <div class="menu-header">Quick Links (Ctrl+)</div>
            </mat-card-title>
            <mat-card-content class="scroll">
              @for (item of quickMenuList; track item; let i = $index) {
                <a tabindex="0" [attr.title]="item.label" (agInteract)="quickmenuLink(item)">
                  <!-- 61817 - Edge browser: VERSO Quick Links: First entry wrongly has vertical space below it -->
                  <span class="quick-desc block-ellipsis pointer pull-left">{{
                    item.label | replaceUserGuidesStringsQuickLinks
                  }}</span>
                  @if (i < 9) {
                    <span class="quick-hotkey badge badge-pill badge-default pull-right pointer">{{
                      i + 1
                    }}</span>
                  }
                  @if (i === 9) {
                    <span class="quick-hotkey badge badge-pill badge-default pull-right pointer"
                      >0</span
                    >
                  }
                </a>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }

      <div
        class="pm-select"
        [ngClass]="{ 'dash-board': !quickMenuList, 'dash-quick': quickMenuList }"
      >
        <ngx-masonry #masonry [options]="masonryKnights" [ordered]="true">
          @for (gMenus of filterStaffList; track gMenus; let i = $index) {
            <div ngxMasonryItem class="card-padding masonry-item">
              <mat-card appearance="outlined" style="padding: 0px">
                <mat-card-title>
                  <div tabindex="0" class="menu-header pointer" (agInteract)="toggleMenu(gMenus)">
                    {{ gMenus?.label }}
                    <i
                      class="fa menu-icon padding-5"
                      aria-hidden="true"
                      [id]="'icon' + i"
                      [ngClass]="gMenus.expanded ? 'fa-compress' : 'fa-expand'"
                    ></i>
                  </div>
                </mat-card-title>
                @if (gMenus.expanded) {
                  <mat-card-content class="scroll menu-content" [id]="'content' + i">
                    @for (item of gMenus.items; track item) {
                      <ul>
                        @if (!item.url?.includes('customer-care') || showCustomerCarePage) {
                          <li class="main-items" [ngClass]="item.url ? 'main-link' : 'no-link'">
                            @if (item.url) {
                              <a
                                tabindex="0"
                                [rel]="gMenus.label + ' > ' + item.label"
                                [id]="'items_' + item.menuItem"
                                (agInteract)="itemClick(item)"
                              >
                                {{ item.label }}
                              </a>
                            } @else {
                              <span [id]="'items_' + item.menuItem">
                                {{ item.label }}
                              </span>
                            }
                            @if (item.url) {
                              <i
                                class="add-quick pull-right fa fa-plus"
                                title="Add to Quick Links"
                                tabindex="0"
                                (agInteract)="addToQuickMenu(item.menuId, item.menuItem)"
                              >
                              </i>
                            }
                            @for (subItem of item.subItems; track subItem) {
                              <ul>
                                <li class="sub-items">
                                  <a
                                    tabindex="0"
                                    [rel]="
                                      $safeNavigationMigration(gMenus?.label) +
                                      ' > ' +
                                      item.label +
                                      ' > ' +
                                      subItem.label
                                    "
                                    [id]="'subItems_' + subItem.menuItem"
                                    (agInteract)="itemClick(subItem)"
                                  >
                                    {{ subItem.label }}
                                  </a>
                                  <i
                                    class="add-quick pull-right fa fa-plus"
                                    title="Add to Quick Links"
                                    tabindex="0"
                                    (agInteract)="addToQuickMenu(subItem.menuId, subItem.menuItem)"
                                  >
                                  </i>
                                </li>
                              </ul>
                            }
                          </li>
                        }
                      </ul>
                    }
                  </mat-card-content>
                }
              </mat-card>
            </div>
          }
        </ngx-masonry>
      </div>
    </div>
  </div>
</main>
